import { render, staticRenderFns } from "./goodsClass.vue?vue&type=template&id=5ed4231d"
import script from "./goodsClass.vue?vue&type=script&lang=js"
export * from "./goodsClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports